import React, { useContext, useState } from 'react'
import styled from 'styled-components'
import TableDataTiny from '../TableDataTiny'
const CardWrapper = styled.div`
    min-height: 150px;
`
const Line = styled.div`
    display: flex;
    align-items: center;
    margin-bottom:0.5rem;
    p{
        font-size: 1.1rem;
        font-family: "Poppins";
        font-weight: 700;
        cursor: pointer;
        margin-right: 0.9rem;
    }

    .check{
        transition: all .2s;
        color:#353535;
    }

    .check::after{
        display: block;
        content: "";
        border-bottom: 1px solid black;
    }


`

const CardTypeTiny = () => {
    const [option, setOption] = useState(1)
    return (

        <CardWrapper >

            <Line>
                <p onClick={() => setOption(1)}className={option == 1 ? 'check' : ''}>itens de produtos ou serviços</p>
                <p onClick={() => setOption(2)}className={option == 2 ? 'check' : ''}>Comissões</p>
                <p onClick={() => setOption(3)}className={option == 3 ? 'check' : ''}>Impostos</p>
            </Line>

            <TableDataTiny option={option}/>

            

        </CardWrapper>

    )
}

export default CardTypeTiny